// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleContents-module--root--3fwlR","title":"ArticleContents-module--title--3OPOC","nav":"ArticleContents-module--nav--3D5Ic"};